<template>
  <div v-show='totalItems > pageSize' :class='b()'>
    <bottom-placeholder v-if='fixed'></bottom-placeholder>
    <div :class="b('pagination-container', {fixed})">
      <pagination
      v-model="currentPage"
      :page-count="pageCount"
      mode="simple"
      @change='onChangePage'></pagination>
    </div>
  </div>
</template>

<script>
import BottomPlaceholder from '../bottom-placeholder'
import Pagination from 'omui/components/pagination'
import create from 'omui/components/utils/create'
export default create({
  name: 'ex-pagination',

  props: {
    value: Number,
    totalItems: {
      type: Number,
      default: 0
    },
    pageSize: {
      type: Number,
      default: 10
    },
    fixed: {
      type: Boolean,
      default: true
    },
    bottom: {
      type: Boolean,
      default: false
    }
  },

  components: {
    BottomPlaceholder,
    Pagination
  },

  computed: {
    pageCount: function () {
      return Math.ceil(this.totalItems / this.pageSize)
    }
  },

  data () {
    return {
      currentPage: this.value
    }
  },

  watch: {
    value: function () {
      this.currentPage = this.value
    }
  },

  methods: {
    onChangePage (page) {
      // window.scrollTo(0, 0)
      this.$emit('input', page)
      this.$emit('change', page)
    }
  }
})
</script>




// WEBPACK FOOTER //
// src/plugins/jscom/omui/combines/ex-pagination/index.vue